import wildfireIconPack from "./packs/fireai_wildfire/icon-map"
import icpIconPack from "./packs/fireai_icp/icon-map"
import auIconPack from "./packs/fireai_au/icon-map"
import nwcgAirOpsPack from "./packs/nwcg_air_ops/icon-map"
import nwcgAssignmentBreakPack from "./packs/nwcg_assignment_break/icon-map"
import nwcgCommunicationsPack from "./packs/nwcg_communications/icon-map"
import nwcgFirePack from "./packs/nwcg_fire/icon-map"
import nwcgIRPack from "./packs/nwcg_ir/icon-map"
import nwcgLogisticsPack from "./packs/nwcg_logistics/icon-map"
import nwcgOpsPack from "./packs/nwcg_ops/icon-map"
import nwcgPropertyPack from "./packs/nwcg_property/icon-map"
import nwcgReferencePack from "./packs/nwcg_reference/icon-map"
import nwcgRepairPack from "./packs/nwcg_repair/icon-map"
import nwcgSafetyPack from "./packs/nwcg_safety/icon-map"
import nwcgTriagePack from "./packs/nwcg_triage/icon-map"
import nwcgWaterPack from "./packs/nwcg_water/icon-map"
import bcwsIconPack from "./packs/bcws/icon-map"
import forestryIconPack from "./packs/forestry/icon-map"

import nwcgLinesAirOps from "./packs/nwcg_lines_air_ops/icon-map"
import nwcgLinesFire from "./packs/nwcg_lines_fire/icon-map"
import nwcgLinesOpsCompleted from "./packs/nwcg_lines_ops_completed/icon-map"
import nwcgLinesOpsPlanned from "./packs/nwcg_lines_ops_planned/icon-map"
import nwcgLinesPerimeterLine from "./packs/nwcg_lines_perimeter_line/icon-map"
import nwcgLinesReference from "./packs/nwcg_lines_reference/icon-map"
import nwcgLinesRepair from "./packs/nwcg_lines_repair/icon-map"
import nwcgLinesRepairStatus from "./packs/nwcg_lines_repair_status/icon-map"
import nwcgLinesSafety from "./packs/nwcg_lines_safety/icon-map"
import nwcgLinesStrategicOperation from "./packs/nwcg_lines_strategic_operation/icon-map"

import nwcgPolygonsFire from "./packs/nwcg_polygons_fire/icon-map"
import nwcgPolygonsIR from "./packs/nwcg_polygons_ir/icon-map"
import nwcgPolygonsReference from "./packs/nwcg_polygons_reference/icon-map"

import nfpaEmergencyIncidents from "./packs/nfpa_emergency_incidents_symbology/icon-map"
import nfpaEmergencyNaturalEvents from "./packs/nfpa_emergency_natural_events_symbology/icon-map"
import nfpaEmergencyOperations from "./packs/nfpa_emergency_operations_symbology/icon-map"
import nfpaFireService from "./packs/nfpa_fire_service/icon-map"
import nfpaGeneralUse from "./packs/nfpa_general_use/icon-map"

import sarcopDamageObservations from "./packs/sarcop_damage_observations/icon-map"
import sarcopHazards from "./packs/sarcop_hazards/icon-map"
import sarcopIncidentSupport from "./packs/sarcop_incident_support/icon-map"
import sarcopSearchHumanNoFollowUp from "./packs/sarcop_search_human_interactions_that_do_not_need_follow_up_by_default/icon-map"
import sarcopSeachHumanWithFollowUp from "./packs/sarcrop_search_human_interactions_that_need_follow_up_by_default/icon-map"
import lineStrokePack from "./packs/line_stroke/icon-map"
import lineWidthPack from "./packs/line_width/icon-map"

import numbers from "./packs/numbers/icon-map"

//Icon Paths are used in DeckGL to render them on the map
//Should be Record<folder_name, iconPack>
const NFPAEmergencyIconPaths = {
    nfpa_emergency_incidents_symbology: nfpaEmergencyIncidents,
    nfpa_emergency_natural_events_symbology: nfpaEmergencyNaturalEvents,
    nfpa_emergency_operations_symbology: nfpaEmergencyOperations,
}

const NFPAFireServicePaths = {
    nfpa_fire_service: nfpaFireService,
}

const NFPAGeneralUsePaths = {
    nfpa_general_use: nfpaGeneralUse,
}

const NWCGIconPaths = {
    nwcg_property: nwcgPropertyPack,
    nwcg_air_ops: nwcgAirOpsPack,
    nwcg_assignment_break: nwcgAssignmentBreakPack,
    nwcg_communications: nwcgCommunicationsPack,
    nwcg_fire: nwcgFirePack,
    nwcg_ir: nwcgIRPack,
    nwcg_logistics: nwcgLogisticsPack,
    nwcg_ops: nwcgOpsPack,
    nwcg_reference: nwcgReferencePack,
    nwcg_repair: nwcgRepairPack,
    nwcg_safety: nwcgSafetyPack,
    nwcg_triage: nwcgTriagePack,
    nwcg_water: nwcgWaterPack,
}

const NWCGLinePaths = {
    nwcg_lines_air_ops: nwcgLinesAirOps,
    nwcg_lines_fire: nwcgLinesFire,
    nwcg_lines_ops_completed: nwcgLinesOpsCompleted,
    nwcg_lines_ops_planned: nwcgLinesOpsPlanned,
    nwcg_lines_perimeter_line: nwcgLinesPerimeterLine,
    nwcg_lines_reference: nwcgLinesReference,
    nwcg_lines_repair: nwcgLinesRepair,
    nwcg_lines_repair_status: nwcgLinesRepairStatus,
    nwcg_lines_safety: nwcgLinesSafety,
    nwcg_lines_strategic_operation: nwcgLinesStrategicOperation,
}

const NWCGPolygonPaths = {
    nwcg_polygons_fire: nwcgPolygonsFire,
    nwcg_polygons_ir: nwcgPolygonsIR,
    nwcg_polygons_reference: nwcgPolygonsReference,
}

const FireAIIconPaths = {
    fireai_wildfire: wildfireIconPack,
    fireai_au: auIconPack,
    fireai_icp: icpIconPack,
}

const BCWSIconPaths = { bcws: bcwsIconPack }

const ForestryIconPaths = { forestry: forestryIconPack }

const SarcopIconPaths = {
    sarcop_damage_observations: sarcopDamageObservations,
    sarcop_hazards: sarcopHazards,
    sarcop_incident_support: sarcopIncidentSupport,
    sarcop_search_human_interactions_that_do_not_need_follow_up_by_default:
        sarcopSearchHumanNoFollowUp,
    sarcrop_search_human_interactions_that_need_follow_up_by_default: sarcopSeachHumanWithFollowUp,
}

const LinePaths = {
    line_stroke: lineStrokePack,
    line_width: lineWidthPack,
}

const NumberPaths = {
    numbers,
}

export {
    FireAIIconPaths,
    NumberPaths,
    NWCGIconPaths,
    BCWSIconPaths,
    ForestryIconPaths,
    SarcopIconPaths,
    LinePaths,
    NWCGLinePaths,
    NWCGPolygonPaths,
    NFPAEmergencyIconPaths,
    NFPAGeneralUsePaths,
    NFPAFireServicePaths,
}
